import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import searchIcon from "./../../media/search-icon.svg";
import sortIcon from "./../../media/sort-icon.svg";
import circleIcon from "./../../media/circle.svg";
import { useNavigate } from "react-router-dom";
import orangeSortIcon from "./../../media/orange-sort-icon.svg";
// import data from "./../../main.json";
import { NavLink } from "react-router-dom";
import { API_URL } from "../../AuthContext";
import Logger from "../../utils/Logger";
import { useNotification } from "../../components/NotificationContext";
import { useAuth } from "../../AuthContext";
import { createPortal } from "react-dom";
import httpClient from "../../services/httpClient";
import { LoadingComponent } from "../../App";
import absencesTableData from "./absencesTable.json";

const MaritexEvery = () => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");
  const [searchBy, setSearchBy] = useState("firstName");
  const [sortedColumn, setSortedColumn] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [absencesData, setAbsencesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const [hover, setHover] = useState(false);
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1380);
  const { userData } = useAuth();

  // Funkcja do formatowania daty na polski format
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const formatted = `${day}.${month}.${year}`;
    return formatted;
  };

  // Wykryj małe ekrany
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1380);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Funkcja do rozwijania/zwijania wierszy
  const toggleRowExpansion = (itemId) => {
    setExpandedRows((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(itemId)) {
        newSet.delete(itemId);
      } else {
        newSet.add(itemId);
      }
      return newSet;
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const absencesResponse = await httpClient.get(
          "absences/future/maritex",
          { withAuth: true },
        );
        const absencesData = absencesResponse.data;
        console.log("Maritex Every - Pobrane dane z API:", absencesData);
        // Dodaj unikalne ID do każdego elementu
        const dataWithIds = absencesData.map((item, index) => ({
          ...item,
          id: item.id || `absence-${index}`,
        }));
        setAbsencesData(dataWithIds);
      } catch (error) {
        setError(error.message);
        Logger.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearchByChange = (criterion) => {
    setSearchBy(criterion);
    setSearchTerm(""); // Resetuje wyszukiwanie po zmianie kryterium
    setIsDropdownOpen(false); // Zamyka dropdown po wybraniu opcji
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSort = (column) => {
    setSortedColumn((prevColumn) => (prevColumn === column ? "" : column));
  };
  const getSortedData = () => {
    const data = [...absencesData];
    if (sortedColumn) {
      return data.sort((a, b) => {
        return a[sortedColumn].localeCompare(b[sortedColumn], "pl", {
          sensitivity: "base",
        });
      });
    }
    return data;
  };

  // Łączenie danych pracowników z nieobecnościami na podstawie employeeId
  const getEmployeeDetails = (employeeId) => {
    return absencesData.find((employee) => employee.id === employeeId);
  };

  const filteredAbsences = getSortedData().filter((item) => {
    if (searchBy === "firstName") {
      // Wyszukiwanie po imieniu i nazwisku
      const fullName = `${item.firstName} ${item.lastName}`.toLowerCase();
      return fullName.includes(searchTerm.toLowerCase());
    }
    return item[searchBy]?.toLowerCase().includes(searchTerm.toLowerCase());
  });

  console.log(
    "Maritex Every - Dane do wyświetlenia (filteredAbsences):",
    filteredAbsences,
  );

  return (
    <div className="absences-container">
      <div className="header">
        <h1>
          {isSmallScreen
            ? t("absences.allAbsences")
            : t("absences.maritexAbsencesAll")}
        </h1>
        <div className="header-right">
          <div className="button-container">
            <button
              className="booking-button"
              onClick={() => navigate(-1)}
              onMouseEnter={() => setHover(true)} // Ustawiamy hover na true, gdy najeżdżamy
              onMouseLeave={() => setHover(false)} // Resetujemy hover na false, gdy opuszczamy
            >
              <div
                className="icon"
                style={{
                  backgroundImage: `url(${hover ? orangeSortIcon : sortIcon})`, // Zmieniamy obrazek w zależności od hover
                  transform: hover ? "scale(1.2)" : "rotate(270deg)", // Powiększamy ikonę przy hover
                }}
              ></div>
              {t("absences.todayAbsences")}
            </button>
          </div>
          <div className="searching">
            <input
              type="text"
              placeholder={
                searchBy === "firstName"
                  ? t("absences.searchByFirstName")
                  : searchBy === "lastName"
                    ? t("absences.searchByLastName")
                    : searchBy === "reason"
                      ? t("absences.searchByReason")
                      : searchBy === "fromDate"
                        ? t("absences.searchByDateFrom")
                        : t("absences.searchByDateTo")
              }
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <div
              className="search-icon"
              style={{ backgroundImage: `url(${searchIcon})` }}
              onClick={() => {}}
            ></div>
            <div
              className={`dropdown ${isDropdownOpen ? "open" : ""}`}
              ref={dropdownRef}
            >
              <button
                className="search-toggle-btn"
                onClick={toggleDropdown} // Kliknięcie otwiera lub zamyka dropdown
              >
                {searchBy === "firstName"
                  ? t("contactDatabase.firstName")
                  : searchBy === "lastName"
                    ? t("contactDatabase.lastName")
                    : searchBy === "reason"
                      ? t("absences.reason")
                      : t("common.date")}
              </button>
              <div className="dropdown-content">
                <button
                  className="dropdown-item"
                  onClick={() => handleSearchByChange("firstName")}
                >
                  {t("contactDatabase.firstName")}
                </button>
                <button
                  className="dropdown-item"
                  onClick={() => handleSearchByChange("lastName")}
                >
                  {t("contactDatabase.lastName")}
                </button>
                <button
                  className="dropdown-item"
                  onClick={() => handleSearchByChange("reason")}
                >
                  {t("absences.reason")}
                </button>
                <button
                  className="dropdown-item"
                  onClick={() => handleSearchByChange("fromDate")}
                >
                  {t("absences.absenceFrom")}
                </button>
                <button
                  className="dropdown-item"
                  onClick={() => handleSearchByChange("toDate")}
                >
                  {t("absences.absenceTo")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="searching mobile-search">
          <input
            type="text"
            placeholder={t("absences.searchByFirstName")}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <div
            className="search-icon"
            style={{ backgroundImage: `url(${searchIcon})` }}
          ></div>
        </div>
      </div>
      {loading ? (
        <LoadingComponent />
      ) : absencesData.length > 0 ? (
        <table className="contact-table">
          <thead>
            <tr>
              <th
                onClick={() => handleSort("firstName")}
                className={sortedColumn === "firstName" ? "sorted-column" : ""}
              >
                {t("contactDatabase.firstName")}
                <img
                  src={sortIcon}
                  alt="Sort Icon"
                  className={`sort-icon ${
                    sortedColumn === "firstName" ? "rotated" : ""
                  }`}
                />
              </th>
              <th
                onClick={() => handleSort("lastName")}
                className={sortedColumn === "lastName" ? "sorted-column" : ""}
              >
                {t("contactDatabase.lastName")}
                <img
                  src={sortIcon}
                  alt="Sort Icon"
                  className={`sort-icon ${
                    sortedColumn === "lastName" ? "rotated" : ""
                  }`}
                />
              </th>
              <th
                onClick={() => handleSort("reason")}
                className={sortedColumn === "reason" ? "sorted-column" : ""}
              >
                {t("absences.reason")}
                <img
                  src={sortIcon}
                  alt="Sort Icon"
                  className={`sort-icon ${
                    sortedColumn === "reason" ? "rotated" : ""
                  }`}
                />
              </th>
              <th
                onClick={() => handleSort("fromDate")}
                className={sortedColumn === "fromDate" ? "sorted-column" : ""}
              >
                {t("absences.absenceFrom")}
                <img
                  src={sortIcon}
                  alt="Sort Icon"
                  className={`sort-icon ${
                    sortedColumn === "fromDate" ? "rotated" : ""
                  }`}
                />
              </th>
              <th
                onClick={() => handleSort("toDate")}
                className={sortedColumn === "toDate" ? "sorted-column" : ""}
              >
                {t("absences.absenceTo")}
                <img
                  src={sortIcon}
                  alt="Sort Icon"
                  className={`sort-icon ${
                    sortedColumn === "toDate" ? "rotated" : ""
                  }`}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredAbsences.map((item, index) => {
              Logger.log("Rendering item:", item);
              const employee = getEmployeeDetails(item.employeeId);
              return (
                <tr
                  key={item.id}
                  className={expandedRows.has(item.id) ? "expanded" : ""}
                  onClick={() => toggleRowExpansion(item.id)}
                >
                  <td>{item.firstName || t("absences.noData")}</td>
                  <td>
                    {isSmallScreen && (
                      <img src={circleIcon} alt="" className="name-icon" />
                    )}
                    {item.lastName || t("absences.noData")}
                  </td>
                  <td>{item.reason}</td>
                  <td>{formatDate(item.fromDate)}</td>
                  <td>{formatDate(item.toDate)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <div className="no-absences">{t("absences.noAbsences")}</div>
      )}
    </div>
  );
};

export default MaritexEvery;
